import { array, boolean, object, string } from 'zod';

export const ANSWER_TEXT_REQUIRED_MESSAGE =
  'Subjective Answer text is required';

export const hasSubjectiveAnswerContent = (answer: { text: string }) =>
  answer.text.length > 0;

export const QuizSubjectiveDataSchema = object({
  answerList: array(
    object({
      key: string(),
      text: string(),
    }).refine(hasSubjectiveAnswerContent, {
      message: ANSWER_TEXT_REQUIRED_MESSAGE,
      path: ['text'],
    }),
  ),
  ignoreSpaces: boolean().optional(),
});
